import type { ReactNode } from 'react';

export const symbol_nest_farsight_weather: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-340h250q46 0 78-32.5t32-77.5q0-45-30.5-76.5T614-560q-13-45-50-72.5T480-660q-41 0-75 21.5T354-579q-48 2-81 36.5T240-460q0 50 35 85t85 35Zm0-60q-25 0-42.5-17.5T300-460q0-25 17-42t41-18h36l14-34q10-21 29.5-33.5T480-600q27 0 48 15.5t29 41.5l12 43h42q21 0 35 14.5t14 35.5q0 20-14.5 35T610-400H360ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
